import { Modal } from '../components/Modal';
import { Button } from '../components/Button';
import { fmt } from '../lib/format';

interface Props {
  onClose(): void;
  onConfirm(): void;
  generatedAt: string;
  rows: number;
  user: string;
}

export function ConfirmDeleteModal({ onClose, onConfirm, generatedAt, rows, user }: Props): JSX.Element {
  return (
    <Modal onClose={onClose}>
      <div className="modal-hd">
        <div className="eb" style={{ color: 'var(--risk)' }}>Destructive</div>
        <div className="ttl">Delete report from {fmt.date(generatedAt)}?</div>
      </div>
      <div className="modal-bd">
        <p style={{ fontSize: 14, color: 'var(--ink)', lineHeight: 1.5 }}>
          This will permanently remove the report and its .xlsx from Storage. Anyone with a deep link
          will get a 404. <strong>This cannot be undone.</strong>
        </p>
        <div className="banner warn">
          <span className="dot" />
          <span>{rows.toLocaleString()} rows · generated by {user} · {fmt.dateTime(generatedAt)}</span>
        </div>
      </div>
      <div className="modal-foot">
        <Button variant="ghost" onClick={onClose}>Cancel</Button>
        <Button variant="destructive" icon="trash" onClick={onConfirm}>Delete report</Button>
      </div>
    </Modal>
  );
}
